export enum ToggleSwitch {
  On = "on",
  Off = "off",
}

export enum PaymentType {
  Withdrawal = "withdrawal",
  Deposit = "deposit",
}

export enum VerificationType {
  Totp = "totp",
  None = "none",
  BankId = "bank_id",
  Sms = "sms",
  LocalMfa = "local_mfa",
  CognitoMfa = "cognito_mfa",
}
